// Adaptador de entitlements para o painel.
//
// Reexporta a funcao pura resolveEntitlements de @lucralink/shared (fonte unica de
// verdade do gating) e expoe um hook fino useEntitlements que resolve as capacidades
// a partir do tenant carregado. O painel usa isso para esconder/desabilitar secoes
// PRO conforme o plano.
//
// Invariante de projeto: entitlement e permissao, NUNCA conversor. Esconder uma secao
// PRO e correto; degradar a geracao de link oficial e proibido.

import { useMemo } from "react";
import {
  resolveEntitlements,
  type Entitlements,
  type Plan,
} from "@lucralink/shared";
import type { Tenant } from "@/lib/types";

export type { Entitlements, Plan };
export { resolveEntitlements };

/** Resolve as capacidades do tenant carregado. Enquanto o tenant nao chega, trata
 *  como free (o tier mais restritivo) para nunca exibir UI PRO antes de confirmar
 *  o plano. proUntil entra como rede de seguranca de expiracao. */
export function useEntitlements(tenant: Tenant | null | undefined): Entitlements {
  return useMemo(
    () => resolveEntitlements(tenant?.plan ?? "free", tenant?.pro_until ?? null),
    [tenant?.plan, tenant?.pro_until],
  );
}
